/* eslint-disable eag/match-named-export -- Pre-existing grab-bag file with several exports */
// Action key prefix for service case integrations
export const SERVICE_CASE_INTEGRATION_ACTION_PREFIX = 'service-case/integration/';
